import { render } from "./FloorplanMap.vue?vue&type=template&id=06137811&ts=true"
import script from "./FloorplanMap.vue?vue&type=script&lang=ts"
export * from "./FloorplanMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__